import { twMerge } from 'tailwind-merge';
import cx, { ArgumentArray } from 'classnames';

export function cn(...inputs: ArgumentArray) {
  return twMerge(cx(inputs));
}
